import { render, staticRenderFns } from "./PushNotification.vue?vue&type=template&id=bfe0968a&scoped=true"
import script from "./PushNotification.vue?vue&type=script&lang=js"
export * from "./PushNotification.vue?vue&type=script&lang=js"
import style0 from "./PushNotification.vue?vue&type=style&index=0&id=bfe0968a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe0968a",
  null
  
)

export default component.exports